import React from "react";
import { Wrapper, SectionHeading, AnchorLink } from "@gw/component-library";
import { BaseLayout } from "../../layouts";
import { ForgotPwd } from "../../components";
import { ForgotPwdPageStyled } from "./ForgotPwdPageStyled";
var ForgotPwdPage = function () {
    return (React.createElement(BaseLayout, null,
        React.createElement(ForgotPwdPageStyled, null,
            React.createElement(Wrapper, { className: "wrapper-auth" },
                React.createElement(AnchorLink, { to: "/" }, "\u2190 Back to Homepage"),
                React.createElement(SectionHeading, { className: "heading" }, "Forgot Password"),
                React.createElement(ForgotPwd, null)))));
};
export default ForgotPwdPage;
//# sourceMappingURL=ForgotPwdPage.js.map